module.exports = __webpack_public_path__ + "static/img/19090D_1_R_20201022_fit.ea876ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19090D_1_R_20201022_fit.png
// module id = LZli
// module chunks = 0